import { buildBingLocationsUrl } from 'src/common/config/bing';
import { request } from 'src/common/rest';
import { TJH_COUNTRIES } from './helpers';

export const GET_BING_LOCATIONS_PENDING = 'GET_BING_LOCATIONS_PENDING';
export const GET_BING_LOCATIONS_SUCCESS = 'GET_BING_LOCATIONS_SUCCESS';
export const GET_BING_LOCATIONS_FAILURE = 'GET_BING_LOCATIONS_FAILURE';
export const SAVE_LAT_LNG = 'SAVE_LAT_LNG';

export const getBingLocationsPending = {
  type: GET_BING_LOCATIONS_PENDING,
};

export const getBingLocationsSuccess = response => ({
  type: GET_BING_LOCATIONS_SUCCESS,
  ...response,
});

export const getBingLocationsFailure = response => ({
  type: GET_BING_LOCATIONS_FAILURE,
  response,
});

export const fetchBingLocations = (addressString, country) => dispatch => {
  dispatch(getBingLocationsPending);
  const url = buildBingLocationsUrl(addressString);

  return request
    .get(url)
    .then(response => {
      if (!response.body.resourceSets[0]) {
        return {
          response,
          locations: [],
        };
      }
      const currentCountry = TJH_COUNTRIES[country];
      const locations = response.body.resourceSets[0].resources
        .filter(resource => resource.address.countryRegion === currentCountry)
        .map(resource => ({
          name: resource.name,
          city: resource.address.locality,
          postcode: resource.address.postalCode,
          lat: resource.point.coordinates[0],
          lng: resource.point.coordinates[1],
        }));

      return {
        response,
        locations,
      };
    })
    .then(response => dispatch(getBingLocationsSuccess(response)))
    .catch(error => dispatch(getBingLocationsFailure(error)));
};

export const saveLatLng = values => ({
  type: SAVE_LAT_LNG,
  lat: values.lat,
  lng: values.lng,
});

export const getLocations = state => state.components.homeAddress.locations;
export const getLat = state => state.components.homeAddress.lat;
export const getLng = state => state.components.homeAddress.lng;
export const isLatLngComplete = state =>
  !!state.components.homeAddress.lat && !!state.components.homeAddress.lng;

export default (state = { locations: [] }, action) => {
  switch (action.type) {
    case GET_BING_LOCATIONS_PENDING: {
      return {
        ...state,
        response: {
          pending: true,
        },
      };
    }
    case GET_BING_LOCATIONS_SUCCESS: {
      return {
        ...state,
        locations: action.locations || [],
        response: {
          ok: action.response.ok,
          status: action.response.status,
        },
      };
    }
    case GET_BING_LOCATIONS_FAILURE: {
      return {
        ...state,
        response: action.response,
      };
    }
    case SAVE_LAT_LNG: {
      return {
        ...state,
        lat: parseFloat(action.lat),
        lng: parseFloat(action.lng),
      };
    }
    default: {
      return state;
    }
  }
  return state;
};
